import { WorkflowTemplate } from "../types";
import { getBadges, formatNumber } from "../utils";
import Badge from "./Badge";
import React from "react";

interface Props {
  workflow: WorkflowTemplate;
  onUse: (workflow: WorkflowTemplate) => void;
}

export default function WorkflowCard({ workflow, onUse }: Props) {
  const badges = getBadges(workflow);

  const isPopular = workflow.usageCount >= 2000;

  return (
    <div
      style={{
        background: "#FFFFFF",
        border: "1px solid #E5E7EB",
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        transition: "all 0.2s ease",
        alignItems: "stretch",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.12)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.08)";
      }}
    >
      {/* Top Section */}
      <div>
        {/* Status Badges (Popular / Recommended / Verified) */}
        <div
          style={{
            display: "flex",
            gap: "8px",
            flexWrap: "wrap",
            marginBottom: "12px",
          }}
        >
          {isPopular && (
            <span
              style={{
                background: "#FEF3C7",
                color: "#B45309",
                fontSize: "12px",
                fontWeight: 600,
                padding: "4px 8px",
                borderRadius: "6px",
              }}
            >
              🔥 Popular
            </span>
          )}

          {workflow.isRecommended && (
            <span
              style={{
                background: "#DBEAFE",
                color: "#1D4ED8",
                fontSize: "12px",
                fontWeight: 600,
                padding: "4px 8px",
                borderRadius: "6px",
              }}
            >
              ⭐ Recommended
            </span>
          )}

          {workflow.isVerified && (
            <span
              style={{
                background: "#D1FAE5",
                color: "#065F46",
                fontSize: "12px",
                fontWeight: 600,
                padding: "4px 8px",
                borderRadius: "6px",
              }}
            >
              ✔ Verified
            </span>
          )}
        </div>

        {/* Title */}
        <h3
          style={{
            fontSize: "20px",
            fontWeight: 600,
            color: "#1F2937",
            marginBottom: "8px",
          }}
        >
          {workflow.name}
        </h3>

        {/* Description */}
        <p
          style={{
            fontSize: "14px",
            color: "#6B7280",
            marginBottom: "16px",
          }}
        >
          {workflow.description}
        </p>

        {/* Tags */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            marginBottom: "16px",
          }}
        >
          {workflow.tags.map((tag) => (
            <span
              key={tag}
              style={{
                fontSize: "12px",
                background: "#F3F4F6",
                color: "#374151",
                padding: "4px 8px",
                borderRadius: "6px",
              }}
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      {/* Bottom Section */}
      <div>
        {/* Stats */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            fontSize: "14px",
            color: "#6B7280",
            marginBottom: "16px",
          }}
        >
          <span>👥 {formatNumber(workflow.usageCount)} uses</span>
          <span>⭐ {workflow.rating}</span>
          <span>🕒 {new Date(workflow.updatedAt).toLocaleDateString()}</span>
        </div>

        {/* CTA */}
        <button
          onClick={() => onUse(workflow)}
          style={{
            width: "100%",
            background: "#714B67",
            color: "white",
            padding: "10px",
            borderRadius: "10px",
            border: "none",
            fontWeight: 500,
            cursor: "pointer",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#5e3d56")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "#714B67")}
        >
          Use Template
        </button>
      </div>
    </div>
  );
}
